import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/App'
import './common'
Vue.use(VueRouter)
new Vue({
    el:"#app",
    router,
    store,
    render:h=>h(App)
})